import AuthProvider, { AuthProviderContext } from "./provider";
import { createProviderHook } from '../helpers'

const useAuth = createProviderHook(AuthProviderContext);

export {
    AuthProvider,
    useAuth
}